import React from 'react'
import empty from '../../assets/icons/circle_empty.svg'
import checked from '../../assets/icons/circle_check_green.svg'
import unChecked from '../../assets/icons/circle_uncheck_yellow.svg'

const FormatCircles = val => {
  if (val === null) {
    return <img className='tac' alt='empty circle' src={empty} />
  }
  if (val === true) {
    return <img className='tac' alt='checked circle' src={checked} />
  }
  if (val === false) {
    return <img className='tac' alt='uncheck circle' src={unChecked} />
  }
}
export default FormatCircles